import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import Link from 'react-router-dom/Link';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);


    //search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const fetchtableData = async () => {
        fetchData('ItemApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Supplier Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}

                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '250px' }}
                        />
                    )}
                </div>


                {hasCreateMasterPermission && (

                    <Tooltip title="Item Registration" arrow>
                        <Button
                            // style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px', marginLeft: '5px' }}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '20px',
                                padding: '5px 10px',
                                border: '1px solid blue',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                textTransform: 'uppercase'

                            }}
                            className="linkcolor"
                            component={Link}
                            to="/ItemCreate"
                        >
                            Create
                        </Button>

                    </Tooltip>
                )}
            </div>

            <div className="watermark" >
                <CopyrightIcon /><b style={{ fontFamily: 'serif' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className='table-header-cell'>Sl.No</TableCell>
                                <TableCell className='table-header-cell'>Category</TableCell>
                                <TableCell className='table-header-cell'>Code</TableCell>
                                <TableCell className='table-header-cell'>Name</TableCell>
                                <TableCell className='table-header-cell'>HSN Code</TableCell>
                                <TableCell className='table-header-cell'>GST %</TableCell>
                                <TableCell className='table-header-cell'>Sale Rate</TableCell>
                                <TableCell className='table-header-cell'>Purchase Rate</TableCell>
                                <TableCell className='table-header-cell'></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out'
                                    }}
                                >
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{index + 1}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.CategoryName}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.Code}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.Name}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.HSNCode}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{Number(item.CGSTRate) + Number(item.SGSTRate)}%</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.SaleRate}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.PurchaseRate}</TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>
                                        {hasEditMasterPermission && (
                                            <Tooltip title="Edit Item" arrow>
                                                <Link to={`/ItemEdit/${item.Id}`}>
                                                    <IconButton color="primary">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Link>
                                            </Tooltip>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <Tooltip title="Delete Item" arrow>
                                                <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
                                                    {item.IsActive ? <DeleteIcon /> : <ActivateIcon />}
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default ItemIndex;

